import LocalizedStrings from 'react-localization';
import { withCommon } from '../../services/common.translations';

const strings = new LocalizedStrings({
  en: {
    delete: {
      title: "Delete document",
      deleteSuccessful: "Successfully deleted",
      message: (name: string) => `Are you sure you want to delete ${name}?`,
      errors: {
        unknown: "Unable to delete- please try again."
      }
    },
    update: {
      title: "Upload new version",
      deleteSuccessful: "Successfully updated",
      message: (name: string) => `This will replace ${name} with a new version of the document.`,
      errors: {
        unknown: "Unable to update- please try again.",
        incorrectFileType: "You can only replace this file with one of the same type."
      }
    },
    documentList: {
      filterPlaceholder: "Filter",
      noDocuments: "No documents were found.",
      noDocumentsMatch: (term: string) => `No documents matching '${term}' were found.`,
      myDocuments: "My Documents"
    }
  }
});

export default withCommon<typeof strings>(strings);
